/**
 * Builds a feeDescription string from a fee amount in euros.
 * Same logic as `withFee` in cancellation-fee-rule.service.ts.
 */
export function buildFeeDescription(feeInEuros) {
    return feeInEuros === 0 ? 'sans frais' : `avec ${feeInEuros.toFixed(2)} € de frais`;
}
/**
 * Formats a condition line into structured text parts with bold flags.
 * Same logic as `ConditionText` in shared-trip-components.tsx.
 *
 * Examples:
 * - allowed + "sans frais" → **Billet modifiable sans frais** (+ éventuel réajustement tarifaire)
 * - allowed + "avec 250.00 € de frais" → **Billet remboursable** avec **250.00 € de frais**
 * - allowed + "avec 150.00 € de frais" + isExchange → **Billet modifiable** avec **150.00 € de frais** (+ éventuelle différence tarifaire en fonction de la nouvelle date)
 * - not allowed → plain feeDescription text
 */
export function formatConditionText(params) {
    const { allowed, feeDescription, isExchange = false, label } = params;
    if (!allowed) {
        return [
            { bold: false, text: feeDescription || `Non ${label.toLowerCase().replace('billet ', '')}` },
        ];
    }
    if (feeDescription === 'sans frais') {
        return [
            { bold: true, text: `${label} sans frais` },
            { bold: false, text: ' (+ éventuel réajustement tarifaire)' },
        ];
    }
    const feeMatch = feeDescription.match(/avec (.+€) de frais/);
    if (feeMatch) {
        const parts = [
            { bold: true, text: label },
            { bold: false, text: ' avec ' },
            { bold: true, text: `${feeMatch[1]} de frais` },
        ];
        if (isExchange) {
            parts.push({
                bold: false,
                text: ' (+ éventuelle différence tarifaire en fonction de la nouvelle date)',
            });
        }
        return parts;
    }
    return [
        { bold: true, text: label },
        { bold: false, text: ` ${feeDescription}` },
    ];
}
